import { useMemo } from 'react';

import { RoomInfo } from '../types/app-types';

type UseMyGamesArgs = {
  activeRooms: RoomInfo[] | undefined;
  activeSingle: RoomInfo[] | undefined;
  activeGames: RoomInfo[] | undefined; // this is gamesInfo passed from parent
  address?: string | null;
};

export function useMyGames({
  activeRooms,
  activeSingle,
  activeGames,
  address,
}: UseMyGamesArgs): RoomInfo[] {
  return useMemo(() => {
    if (!activeRooms?.length && !activeGames?.length) return [];

    const sortedRooms = (activeRooms ?? []).filter(
      (room) =>
        room.data.playerA?.toLowerCase() === address?.toLowerCase() ||
        room.data.playerB?.toLowerCase() === address?.toLowerCase(),
    );

    const banned = new Set([
      ...sortedRooms.map((g) => g.data.roomId),
      ...activeSingle.map((g) => g.data.roomId),
    ]);

    const filteredActiveGames = activeGames?.filter((game) => !banned.has(game.data.roomId)) ?? [];

    const merged = [...sortedRooms, ...filteredActiveGames];
    return merged;
  }, [activeRooms, activeSingle, activeGames, address]);
}
